// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__VYUX0","title":"Images45_title__1Uq8c","images":"Images45_images__2Z3Bx"};